import * as React from "react";
import Button from "@mui/material/Button";
import { useState } from "react";
import { Avatar, Divider } from "@mui/material";
import bookmark from "../../assets/img/3.png";
import "react-toastify/dist/ReactToastify.css";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import "../../assets/css/Noti.css";
import { useRef } from "react";
import { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Link } from "react-router-dom";
import BookmarkAddedIcon from "@mui/icons-material/BookmarkAdded";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { ToastContainer, toast } from "react-toastify";
import { FaEdit, FaRegTimesCircle, FaTrash } from "react-icons/fa";
import preloadimg from "../../assets/img/preloader1.gif";
import $ from "jquery";
import { useBookmark } from "../../hooks/useBookmark";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function Bookmark() {
  // const notify = () => toast("Wow so easy!");
  const { fetchBookmarks, deleteBookmark: deleteBookmarkApi, updateBookmarkTitle } = useBookmark();
  const [isLoading, setisLoading] = useState(false);
  const [openNoti, setopenNoti] = useState(false);
  const divRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [saveReports, setSaveReports] = useState([]);
  const [LoadingUpdate, setLoadingUpdate] = useState(false);
  const [reportIdtext, setreportIdtext] = useState();
  const [reportTitletext, setreportTitletext] = useState("");
  const [Saving, setSaving] = useState(false);

  useEffect(() => {
    GetSaveReports();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const GetSaveReports = async () => {
    try {
      const data = await fetchBookmarks();
      setSaveReports(data);
      setisLoading(false);
    } catch {
      setSaveReports(null);
      setisLoading(false);
    }
  };

  const removeBookmark = (id, page, title) => {
    setSaving(true);
    deleteBookmarkApi(id, page, title)
      .then(() => {
        GetSaveReports();
        setSaving(false);
        toast.success(`${decodeURIComponent(title)} Deleted Successfully`, {
          // Set to 15sec
          position: toast.POSITION.BOTTOM_LEFT,
          autoClose: 6000,
        });
      })
      .catch((error) => {
        setSaving(false);
        alert("Error deleting resource:", error);
      });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const UpdateTitle = () => {
    if (reportTitletext === "") return false;

    setLoadingUpdate(true);

    updateBookmarkTitle(reportIdtext, reportTitletext)
      .then(() => {
        GetSaveReports();
        setLoadingUpdate(false);
        setOpen(false);
      })
      .catch((error) => {
        console.log(error);
        setLoadingUpdate(false);
        alert("Error");
      });
  };

  const openEditBox = (id, title) => {
    setreportIdtext(id);
    setreportTitletext(title);
    setOpen(!open);
  };

  const handleOutsideClick = (event) => {
    if (divRef.current && !divRef.current.contains(event.target) && !open) {
      return setopenNoti(false);
    }
  };

  useEffect(() => {
    // Attach the event listener when the component mounts
    document.addEventListener("mousedown", handleOutsideClick);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // Clean up the event listener if 'open' becomes true
    return () => {
      if (!open) {
        document.removeEventListener("mousedown", handleOutsideClick);
      }
    };
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const notififactionTrigger = (id) => {
    GetSaveReports();
    $(".notifications").toggle(false);
    setopenNoti(!openNoti);
  };

  function getUserGroupLabel(userGroupId) {
    let label;

    switch (userGroupId) {
      case 101:
        label = "Dealer";
        break;
      case 102:
        label = "Field";
        break;
      case 103:
        label = "Headquarter";
        break;
      case 104:
        label = "Admin";
        break;
      default:
        label = undefined;
        break;
    }

    return label;
  }

  return (
    <div id="NotificationDrawer">
      <>
        <Button
          id="NotiIconsnew"
          onClick={() => {
            setopenNoti(!openNoti);
            notififactionTrigger();
          }}
        >
          <BookmarkAddedIcon sx={{ marginRight: "20px" }} />
        </Button>

        {isLoading && (
          <>
            {openNoti && (
              <>
                <ul
                  ref={divRef}
                  style={{ display: "block" }}
                  className="dropdown-menu bookmarkDiv"
                  role="menu"
                  aria-labelledby="dLabel"
                >
                  <div
                    style={{ width: "auto", height: "500px" }}
                    className="loadingBookmark"
                  >
                    Getting your bookmark, please wait...
                  </div>
                </ul>
              </>
            )}
          </>
        )}

        {!isLoading && (
          <>
            {openNoti && (
              <ul
                ref={divRef}
                style={{ display: "block" }}
                className="dropdown-menu bookmarkDiv"
                role="menu"
                aria-labelledby="dLabel"
              >
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      alignContent: "center",
                    }}
                  >
                    <div
                      style={{
                        padding: "1rem",
                        fontSize: "20px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      All Bookmarks
                    </div>

                    <div style={{ paddingRight: "1.2rem" }}>
                      <FaRegTimesCircle
                        onClick={() => setopenNoti(!openNoti)}
                        style={{ fontSize: "20px", cursor: "pointer" }}
                      />
                    </div>
                  </div>
                  <Divider />

                  {saveReports.length === 0 && (
                    <div style={{ height: "100%" }} className="noBookmark">
                      <div>
                        <img width={200} src={bookmark} alt="bookmark" />
                      </div>
                      <div style={{ display: "grid", gridGap: "6px" }}>
                        <span
                          style={{
                            fontSize: "20px",
                            color: "gray",
                            fontWeight: "600",
                          }}
                        >
                          {" "}
                          Add Bookmark
                        </span>
                        <span
                          style={{
                            width: "80%",
                            display: "block",
                            margin: "auto",
                            color: "gray",
                            fontSize: "14px",
                          }}
                        >
                          {" "}
                          Don't forget to bookmark the report you like most so
                          that you can find those easily over here
                        </span>
                      </div>
                    </div>
                  )}

                  {saveReports.length !== 0 && (
                    <div className="all-bookmark">
                      {saveReports.map((saved, index) => {
                        return (
                          <div
                            className="bookmark-items"
                            key={index}
                            style={{
                              padding: "15px",
                              borderBottom: "1px solid #eee",
                              display: "flex",
                              alignItems: "center",
                              alignContent: "center",
                              gridGap: "10px",
                              justifyContent: "space-between",
                            }}
                          >
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                alignContent: "center",
                                gridGap: "10px",
                              }}
                            >
                              <Avatar>{saved.title.charAt(0)}</Avatar>
                              <div style={{ display: "grid", gap: "5px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    alignContent: "center",
                                    justifyContent: "space-between",
                                    width: "100%",
                                  }}
                                >
                                  <Link
                                    style={{
                                      textDecoration: "none",
                                      background: "none",
                                    }}
                                    className="bookmarkListItmes"
                                    to={`/reports/${parseInt(
                                      saved.reportId
                                    )}/view?ReportSection=${saved.pagename}`}
                                    onClick={() => {
                                      if (saved.filterJson || saved.slicerJson) {
                                        sessionStorage.setItem(
                                          "bookmark-restore",
                                          JSON.stringify({
                                            pagename: saved.pagename,
                                            filterJson: saved.filterJson || null,
                                            slicerJson: saved.slicerJson || null,
                                          })
                                        );
                                      } else {
                                        sessionStorage.removeItem("bookmark-restore");
                                      }
                                    }}
                                  >
                                    <span>{saved.title}</span>
                                  </Link>
                                </div>

                                <div style={{ display: "flex", gap: "10px" }}>
                                  <span
                                    style={{
                                      background: "#eee",
                                      paddingLeft: "5px",
                                      paddingRight: "5px",
                                      color: "#283978",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {getUserGroupLabel(saved.userGroupId)}
                                  </span>
                                  <span
                                    style={{
                                      background: "#eee",
                                      paddingLeft: "5px",
                                      paddingRight: "5px",
                                      color: "#283978",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {saved.reportName}
                                  </span>
                                </div>
                              </div>
                            </span>

                            <div style={{ display: "flex", gridGap: "20px" }}>
                              <FaEdit
                                style={{
                                  color: "#253978",
                                  fontSize: "12px",
                                  cursor: "pointer",
                                }}
                                onClick={(e) =>
                                  openEditBox(saved.id, saved.title)
                                }
                              />

                              <FaTrash
                                onClick={(e) =>
                                  removeBookmark(
                                    parseInt(saved.reportId),
                                    saved.pagename,
                                    saved.title
                                  )
                                }
                                style={{
                                  color: "#dc3545",
                                  fontSize: "12px",
                                  cursor: "pointer",
                                }}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {Saving && (
                    <div
                      style={{
                        position: "fixed",
                        background: "rgba(0,0,0,0.8)",
                        width: "100%",
                        height: "100%",
                        top: "0",
                        left: "0",
                        right: "0",
                        bottom: "0",
                        display: "grid",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "white",
                        zIndex: "99999",
                        justifyItems: "center",
                        alignContent: "center",
                      }}
                    >
                      <img width={200} src={preloadimg} alt="Loading" />
                      <span>Deleting your bookmark...</span>
                    </div>
                  )}
                </div>
              </ul>
            )}
          </>
        )}
      </>

      <ToastContainer />

      <Dialog open={open} onClose={(e) => setOpen(!open)}>
        <DialogTitle
          style={{ background: "#A70E13", color: "#fff", fontWeight: "500" }}
        >
          Rename Your Bookmark Title
        </DialogTitle>
        <DialogContent>
          {/* <DialogContentText>
            <div
              style={{
                display: "flex",
                gridGap: "10px",
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <Avatar>N</Avatar>
              <div style={{ display: "grid" }}>
                <span> {userInfo?.given_name}</span>
                <span style={{ fontSize: "14px" }}>{userInfo?.email}</span>
              </div>
            </div>
          </DialogContentText> */}
          <TextareaAutosize
            value={reportTitletext}
            onChange={(e) => setreportTitletext(e.target.value)}
            style={{
              width: "100%",
              height: "auto",
              minHeight: "50px",
              border: "2px solid #eee",
              padding: "10px",
              borderRadius: "6px",
              marginTop: "24px",
              minWidth: "400px",
              maxWidth: "400px",
              resize: "none",
            }}
            className="popup-input"
            placeholder="Rename your Bookmark"
          />
        </DialogContent>
        <DialogActions id="postCommentActions">
          <Button className="cancel_btn" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className="submit_btn postcls"
            disabled={LoadingUpdate}
            onClick={UpdateTitle}
          >
            {LoadingUpdate ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span style={{ paddingLeft: "10px" }}>Updating...</span>
              </>
            ) : (
              "Rename"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
